export const LanguageMap = ["EN", "RU", "PL", "LT", "LV", "AU", "BG"];
